
import Vue from "vue";
import Dashboard from "@/components/User/Dashboard.vue";

export default Vue.extend({
  name: "UserWidgetMesages",
  components: {
    Dashboard
  },
  props: {},
  data() {
    return {};
  }
});
